<template>

  <div class="frankinForm__saveProgress saveProgress saveProgress--full saveProgress--paddingLarge" style="margin-top:0;">
    <section class="formIntro">
      <div class="in container">
        <h4>Let’s get started!</h4>
        <p>You are just a few minutes away from your franking machine quote.</p>
        <p>We search and compare all manufacturer models in the market place e.g. Pitney Bowes, Quadient (Neopost), FP and Frama. No need to speak to salespeople and filter out what is actually best for your business, we provide the facts with a full savings and return on investment calculation.</p>
        <p>Its important you answer all questions to the best of your ability, the detail entered will be used to calculate your savings, return on investment summary and provide you with a choice of suitable solutions from each manufacturer relevant to your specific business requirements.</p>
        <!--<a href="#" class="btn btn&#45;&#45;base" tabindex="0" v-if="currentStep == 1">Lets Go!</a>-->
        <a href="#" class="btn btn--base" tabindex="0" v-if="currentStep > 1" @click="stepBack">Go Back</a>
      </div>
    </section>
    <div class="in container">
      <div class="saveProgress__content">
        <h4>Click here to confirm your details and schedule a time for a call back to discuss</h4>
        <p id="em">We are appointing a dedicated support agent to review the market for you, this is to help you through the process and to achieve the best technology at the best rate.</p>
      </div>
      <div class="saveProgress__form">
        <div class="saveProgress__inputBlock" :class="{'inputPanel__error lead_error' : invalidLeadFields.company_name}">
          <input type="text" v-model="company_name" id="over2CompanyName" placeholder="Company Name" class="inputLarge">
          <div class="errorMsg" v-if="invalidLeadFields.company_name">
            <span>Please enter your company name above and click Save</span>
          </div>
        </div>
        <div class="saveProgress__inputBlock" :class="{'inputPanel__error lead_error' : invalidLeadFields.name}">
          <input type="text" v-model="name" id="over2Name" placeholder="Name" class="inputLarge">
          <div class="errorMsg" v-if="invalidLeadFields.name">
            <span>Please enter your name above and click Save</span>
          </div>
        </div>
        <div class="saveProgress__inputBlock" :class="{'inputPanel__error lead_error' : invalidLeadFields.contact_phone}">
          <input type="text" v-model="phone" id="over2Phone" placeholder="Contact Telephone Number" class="inputLarge">
          <div class="errorMsg" v-if="invalidLeadFields.contact_phone">
            <span v-if="phone && phone.length < 11">The number is to short.</span>
            <span v-else-if="phone && phone.length > 11">The number should accept only 11 digit numbers (no spaces).</span>
            <span v-else>Please enter a valid phone number and click Save.</span>
          </div>
        </div>
        <div class="saveProgress__inputBlock" :class="{'inputPanel__error lead_error' : invalidLeadFields.email}">
          <input type="email" v-model="email" id="over2Email" placeholder="Email" class="inputLarge">
          <div class="errorMsg" v-if="invalidLeadFields.email">
            <span>Please enter a valid email above and click Save</span>
          </div>
        </div>
        <div class="saveProgress__inputBlock" :class="{'inputPanel__error lead_error' : invalidLeadFields.contact_time}">
          <datetime ref="datetime" v-model="contact_time" format="yyyy-LL-dd HH:mm:ss" type="datetime"></datetime>
          <input type="text" autocomplete="off" v-model="contact_time_show" @click="clickDatetime" :readonly="true" placeholder="Date & Time" class="inputLarge" id="over2time">
          <div class="errorMsg" v-if="invalidLeadFields.contact_time">
            <span>Please enter date & time above and click Save</span>
          </div>
        </div>
        <input id='saveOver2Submit' type="submit" value="save" @click.prevent="onSubmit">
      </div>
    </div>
  </div>
</template>

<script>
  import {Datetime} from 'vue-datetime'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import moment from 'moment'

  export default {
    components: {
      datetime: Datetime
    },

    data() {
      return {
        contact_time_show: null,
        currentStep: 1
      }
    },

    computed: {
      ...mapState('LeadForm', ['form_data', 'invalidLeadFields']),
      company_name: {
        get() {
          return this.form_data.company_name
        },
        set(value) {
          this.updateFormData({company_name: value})
        }
      },
      name: {
        get() {
          return this.form_data.name
        },
        set(value) {
          this.updateFormData({name: value})
        }
      },
      phone: {
        get() {
          return this.form_data.phone
        },
        set(value) {
          this.updateFormData({phone: value})
        }
      },
      email: {
        get() {
          return this.form_data.email
        },
        set(value) {
          this.updateFormData({email: value})
        }
      },
      contact_time: {
        get() {
          if (this.form_data.contact_time) {
            this.contact_time_show = moment(this.form_data.contact_time).format("YYYY-MM-DD HH:mm:ss")
          }
          return this.form_data.contact_time
        },
        set(value) {
          if (value) {
            this.contact_time_show = moment(value).format("YYYY-MM-DD HH:mm:ss")
          }
          this.updateFormData({contact_time: value})
        }
      }
    },

    methods: {
      ...mapMutations('LeadForm', ['updateFormData']),
      ...mapActions('LeadForm', ['submitForm']),
      onSubmit() {
        this.submitForm()
      },
      clickDatetime() {
        $('.vdatetime-input').click();
      }
    }

  }
</script>
<style lang="scss">
  #over-two-error-box{
    margin-top: 20px;
    border: 5px solid #D55051;
    padding: 11px 25px;
    background: #E87B7B;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    display:block !important
  }
  #over-two-error-box:empty{display: none !important}

  #over-two-error-box > div:not(:first-child){
    margin-top:7px
  }

  .vdatetime-input {
    display: none;
  }

  .lead_error {
    display: flex;
    flex-direction: column;
    .errorMsg {
      margin-top: 26px;
      span {
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Quotes/Form/Step-1/Conditionals/Form_MachinesAmountOver10.vue